// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteLeads_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /config/site_leads/get/{id} — one lead, staff view. */
import type { SiteLeads_LeadRow } from './SiteLeads_LeadRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SiteLeads_GetResponseDados {
lead: SiteLeads_LeadRow
}

export type SiteLeads_GetResponse = ApiResponse<SiteLeads_GetResponseDados>;

registerResponseContract('SiteLeads_GetResponse', {
  lead: {
    type: 'object',
    required: true,
    fields: {
      id:          { type: 'number',  required: false },
      event_id:    { type: 'string',  required: false },
      tenant:      { type: 'string',  required: false },
      formulario:  { type: 'string',  required: false },
      finalidade:  { type: 'string',  required: false },
      cliente_id:  { type: 'number',  required: false },
      recebido_em: { type: 'string',  required: false },
      origem_ip:   { type: 'string',  required: false },
      resumo: {
        type: 'object',
        required: false,
        fields: {
          nome:     { type: 'string',  required: false },
          email:    { type: 'string',  required: false },
          telefone: { type: 'string',  required: false },
        },
      },
      payload: {
        type: 'object',
        required: false,
        fields: {
          event_id:          { type: 'string',  required: false },
          event:             { type: 'string',  required: false },
          tenant:            { type: 'string',  required: false },
          formulario:        { type: 'string',  required: false },
          formulario_versao: { type: 'number',  required: false },
          occurred_at:       { type: 'string',  required: false },
          data:              { type: 'object',  required: false },
          campanha:          { type: 'object',  required: false },
        },
      },
    },
  },
})
